import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CalendarItemEnum } from 'src/app/models/enums/calendarItemType';

@Component({
  selector: 'app-event-share-button',
  templateUrl: './event-share-button.component.html',
  styleUrls: ['./event-share-button.component.scss']
})
export class EventShareButtonComponent {
  @Input({ required: true }) btnText!: string;
  @Output() addToCalendarClick = new EventEmitter<CalendarItemEnum>();
  CalendarItemEnum = CalendarItemEnum;

  shareClick(event:any, type: CalendarItemEnum) {
    event.preventDefault();
    this.addToCalendarClick.emit(type);
  }
}
